<template>
  <div class="mx-3 my-3 pb-4">
    <div class="grid grid-cols-12 gap-4">
      <div class="flex flex-col col-span-12 md:col-span-2" style="cursor: pointer;">
        <div
          :class="currentRoute === 'flags' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('flags')"
        >
          <div class="flex">
            <div>Feature flags</div>
          </div>
        </div>
        <div
          :class="currentRoute === 'audit' ? 'menu-pill-active' : 'menu-pill'"
          @click="select('audit')"
        >
          <div class="flex">
            <div>Audit logs</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 md:col-span-10">
        <FeatureFlagsList v-if="currentRoute === 'flags'" ref="flagsRef" />
        <FeatureFlagsAudit v-if="currentRoute === 'audit'" ref="auditRef" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from "vue";
import FeatureFlagsList from "./FeatureFlagsList.vue";
import FeatureFlagsAudit from "./FeatureFlagsAudit.vue";

type TabChild = { refresh?: () => void } | null;
type FeatureFlagsRoute = "flags" | "audit";

const currentRoute = ref<FeatureFlagsRoute>("flags");
const flagsRef = ref<TabChild>(null);
const auditRef = ref<TabChild>(null);

const refreshActiveTab = () => {
  if (currentRoute.value === "flags") flagsRef.value?.refresh?.();
  else if (currentRoute.value === "audit") auditRef.value?.refresh?.();
};

const select = (route: FeatureFlagsRoute) => {
  currentRoute.value = route;
  nextTick(() => refreshActiveTab());
};

defineExpose({ refresh: refreshActiveTab });
</script>
